/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/client";
import type { DeleteDeleteConfigurationMutationResponse, DeleteDeleteConfigurationPathParams, DeleteDeleteConfiguration404 } from "../../models/DeleteDeleteConfiguration";
import type { RequestConfig, ResponseErrorConfig } from "@/client";

function getDeleteDeleteConfigurationUrl({ uuid }: { uuid: DeleteDeleteConfigurationPathParams["uuid"] }) {
  const res = { method: 'DELETE', url: `/api/v1/configurations/${uuid}` as const }  
  return res
}

/**
 * {@link /api/v1/configurations/:uuid}
 */
export async function deleteDeleteConfiguration({ uuid }: { uuid: DeleteDeleteConfigurationPathParams["uuid"] }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<DeleteDeleteConfigurationMutationResponse, ResponseErrorConfig<DeleteDeleteConfiguration404>, unknown>({ method : "DELETE", url : getDeleteDeleteConfigurationUrl({ uuid }).url.toString(), ... requestConfig })  
  return res.data
}